<template>
  <md-dialog
      :md-opened="openDialog"
      :md-closed="closeDialog"
      :md-active.sync="options.showImportTripForm"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      :class="[ 'import-trip-dialog','reimport-mode' ]"
  >
    <div class="modal-blur-wrapper" :class="{ 'blurred-content': ladebalken }">
      <!-- HEADER -->
      <div class="header-row">

        <md-dialog-title class="dialog-title">
          {{ localCurrentTrip?.isReimport ? options.Lang.Vorgang_bearbeiten : options.Lang.Neuen_Vorgang_importieren }}
        </md-dialog-title>
        <NezasaIdBox v-if="localCurrentTrip" :tripid="form.nezasa_id"/>
      </div>

      <!-- CONTENT -->
      <md-dialog-content >
        <div class="content-area">

          <form class="form-grid" @submit.prevent="validate">

            <!-- NEZASA INPUT (only when NEW import) -->
            <div class="grid-col grid-full" v-if="!localCurrentTrip">
              <md-field id="import-nezasa-input" class="md-focused" :class="getValidationClass('nezasa_id')">
                <label class="font-600">Nezasa ID<span class="md-required">*</span></label>
                <md-input v-model="form.nezasa_id" placeholder="Nezasa ID"/>
                <span class="md-error" v-if="!$v.form.nezasa_id.required">{{ options.Lang.Bitte_ausfüllen }}</span>
              </md-field>
            </div>

            <!-- BRANDING -->
            <div class="grid-col">
              <md-field class="md-focused" :class="getValidationClass('branding')">
                <label class="font-600">Branding<span class="md-required">*</span></label>
                <md-select v-model="form.branding">
                  <md-option
                      v-for="brand in brands"
                      :key="brand.id"
                      :value="String(brand.id)"
                  >{{ brand.adresse }}</md-option>
                </md-select>

                <span class="md-error" v-if="!$v.form.branding.required">{{ options.Lang.Bitte_ausfüllen }}</span>
              </md-field>
            </div>

            <!-- MITARBEITER -->
            <div class="grid-col">
              <md-field class="md-focused" :class="getValidationClass('mitarbeiter')">
                <label class="font-600">{{ options.Lang.Mitarbeiter }}<span class="md-required">*</span></label>

                <md-select
                    v-model="form.mitarbeiter"
                    @md-selected="changeSalesName"
                    :disabled="options.user.trips_isolated === 1"
                >

                  <template v-if="options.user.trips_isolated === 1">
                    <md-option :value="options.user.id">
                      {{ options.user.firstname }} {{ options.user.lastname }}
                    </md-option>
                  </template>

                  <template v-else>
                    <md-option
                        v-for="(arbeiter,index) in mitarbeiter"
                        :key="index"
                        :value="arbeiter.id"
                    >{{ arbeiter.firstname }} {{ arbeiter.lastname }}</md-option>
                  </template>

                </md-select>

                <span class="md-error" v-if="!$v.form.mitarbeiter.required">{{ options.Lang.Bitte_ausfüllen }}</span>
              </md-field>
            </div>

          </form>

        </div>
      </md-dialog-content>

      <!-- ACTIONS -->
      <md-dialog-actions class="actions-row">

        <md-button class="md-raised secondary" @click="closeDialog">
          <strong>{{ options.Lang.close_window }}</strong>
        </md-button>

        <div class="right-actions">

          <md-button
              v-if="localCurrentTrip"
              id="uploadButton2"
              class="md-raised md-primary"
              @click="saveBranding"
              disabled
          >
            <strong>{{ options.Lang.changeBranding }}</strong>
          </md-button>

          <md-button
              id="uploadButton"
              class="md-raised md-primary"
              @click="save"
              disabled
          >
            <strong>{{ localCurrentTrip ? options.Lang.Vorgang_neu_importieren : options.Lang.Vorgang_importieren }}</strong>
          </md-button>

        </div>

      </md-dialog-actions>
    </div>
    <Success :options="options"/>
    <Error v-if="options.showError && options.user.loggedIn" :options="options"/>

    <section v-if="ladebalken" class="loading_spinner">
      <div class="ladebalken">
        <div class="custom-spinner"></div>
      </div>
    </section>
  </md-dialog>
</template>
<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import Success from '../../components/dialogs/Success.vue'
import Error from '../../components/dialogs/Error.vue'
import NezasaIdBox from '../../components/parts/NezasaIdBox.vue'

export default {
  name: 'formImportTrip',
  mixins: [validationMixin],
  components: {
    Success, Error, NezasaIdBox
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    mitarbeiter: [],
    defaultbrand: null,
    brands: [],
    loaded: false,
    ladebalken: false,
    LadebalkenCount: 0,
    amount: 0,
    trip: null,
    form: {
      nezasa_id: null,
      branding: null,
      mitarbeiter: null,
      sales_firstname: null,
      sales_lastname: null,
      // the chosen Mitarbeiter's user id — the backend resolves the travel
      // expert by this, the names only serve the trip list and old trips
      sales_user_id: null
    },
    tripSaved: false,
    sending: false,
  }),
  computed: {
    localCurrentTrip: {
      get(){
        return this.currentTrip;
      },
      set(trip){
        this.$emit('update:currentTrip', trip);
      }
    }
  },
  validations: {
    form: {
      nezasa_id: {
        required,
      },
      branding: {
        required,
      },
      mitarbeiter: {
        required,
      }
    }
  },
  updated(){
    if(this.form.nezasa_id == null || this.form.nezasa_id === "" ||  this.form.nezasa_id === "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("uploadButton")
      button.removeAttribute("disabled")
    }
  },
  async mounted() {
    let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    this.loaded = false;
    if(!this.localCurrentTrip || !this.localCurrentTrip.Branding){
      await this.getDefaultBrand();
      await this.getBrandings();
    }
    await this.getBrandings();
    this.options.errorMsg = "Es gab ein Problem. Bitte später nochmals probieren."
    this.trip = this.localCurrentTrip;
    this.form.sales_firstname = this.options.user.firstname;
    this.form.sales_lastname =  this.options.user.lastname;
    // re-import keeps the trip's stored salesman; a fresh import defaults to me
    this.form.sales_user_id = this.localCurrentTrip?.sales_user_id || this.options.user.id;
    await this.getMitarbeiter();
    if(this.form.nezasa_id == null || this.form.nezasa_id === "" ||  this.form.nezasa_id === "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("uploadButton")
      button.removeAttribute("disabled")
    }
    if(this.localCurrentTrip?.autoImport){
        setTimeout(() => { button.click() }, 500)
    }
    this.ladebalken = false;
  },
  watch: {
    localCurrentTrip: {
      handler(newValue) {
        if (newValue) {
          let self = this;
          self.trip = newValue ? newValue : null;
          self.form.offer_id = newValue ? newValue.offer_id : null;
          self.form.nezasa_id = newValue ? newValue.nezasa_id : null;
          self.form.sales_firstname = newValue ? newValue.sales_firstname : null;
          self.form.sales_lastname = newValue ? newValue.sales_lastname : null;
          self.form.sales_user_id = newValue ? newValue.sales_user_id || null : null;
        }
      },
      deep: true,
      immediate: true,
    },
    brands(newVal) {
      if (!this.form.branding && Array.isArray(newVal) && newVal.length) {
        this.form.branding = String(newVal[0].id);
      }
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      const icon = event.currentTarget; // the SVG/icon element
      icon.classList.add('copy-animate');

      setTimeout(() => {
        icon.classList.remove('copy-animate');
      }, 300); // remove after animation
    },
    async loadJsonField(key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    async setLoginCode(id){
      let self = this;
      await this.doPost({data: id}, 'setLoginCode', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      }
      });
    },
    changeSalesName(){
      this.mitarbeiter.forEach(element =>{
        if(element.id === this.form.mitarbeiter){
          this.form.sales_firstname = element.firstname
          this.form.sales_lastname = element.lastname
          this.form.sales_user_id = element.id
        }
      })
    },
    async getMitarbeiter(){
      let self = this;
      if(this.options.user.trips_isolated !== 1){
        await self.doPost({user: self.options.user}, 'getmyUsers', res => {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            let result = res.data;
            self.mitarbeiter = result.data;
            if(!self.localCurrentTrip){
              // new import: default to the logged-in user by id (two same-named
              // users would otherwise both match), name match as a last resort
              const me = self.mitarbeiter.find(element => Number(element.id) === Number(self.options.user.id));
              self.mitarbeiter.forEach(element =>{
                const matches = me
                  ? Number(element.id) === Number(me.id)
                  : (element.firstname === self.form.sales_firstname && element.lastname === self.form.sales_lastname);
                if(matches){
                  self.form.mitarbeiter = element.id
                  self.form.sales_user_id = element.id
                }
              })
            }else{
              // re-import: pre-select the stored salesman by id; trips imported
              // before sales_user_id existed fall back to the name match
              const storedId = self.localCurrentTrip.sales_user_id ? Number(self.localCurrentTrip.sales_user_id) : null;
              self.mitarbeiter.forEach(element =>{
                const matches = storedId
                  ? Number(element.id) === storedId
                  : (element.firstname === self.localCurrentTrip.sales_firstname && element.lastname === self.localCurrentTrip.sales_lastname);
                if(matches){
                  self.form.mitarbeiter = element.id
                  self.changeSalesName()
                }
              })
            }
          }
        });
      }
      else{
        // isolated user: no employee list is loaded, so changeSalesName() can't
        // set the id — the salesman is the logged-in user
        self.form.mitarbeiter = this.options.user.id;
        self.form.sales_user_id = this.options.user.id;
        self.changeSalesName();
      }
      if(self.localCurrentTrip){
        document.getElementById("uploadButton2").disabled = false; 
      }
      document.getElementById("uploadButton").disabled = false;
    },
    async getDefaultBrand(){
      let self = this;
      await self.doPost({}, 'getglobalinfo', res => {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data[0];
        self.defaultbrand = result.normalBrand;
      }
    });
    },
    getBrandings(){
      this.renderComp = false;
      let self = this;
      self.brands = []
    self.doPost({}, 'getAllBranding', res => {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.brands = []
        let result = res.data.data;

        let userBrandingsAllowed = JSON.parse(self.options.user.brandings)

        for(let i = 0; i < result.length; i++){
          if (userBrandingsAllowed.includes(result[i].id)) {
            self.brands.push(result[i])
          }
        }

        // Set default branding first
        let brandingSet = false;

        // If there's a current trip, try to match its branding first
        if(self.localCurrentTrip && self.localCurrentTrip.Branding){
          self.brands.forEach(brand=>{
            if(brand.adresse === self.localCurrentTrip.Branding){
              self.form.branding = String(brand.id);
              brandingSet = true;
            }
          })
        }
        // If no trip-specific branding was set, check if default brand is in user's allowed list
        if(!brandingSet && self.defaultbrand != null && userBrandingsAllowed.includes(parseInt(self.defaultbrand, 10))){
          self.form.branding = String(self.defaultbrand);
          brandingSet = true;
        }

        // If still no branding set and we have brands available, use first one from user's allowed brands
        if(!brandingSet && self.brands.length > 0){
          self.form.branding = String(self.brands[0].id);
          brandingSet = true;
        }

        self.loaded = true;

        // Force Vue to update the select component
        self.$nextTick(() => {
          self.$forceUpdate();
        });
      }
    });

    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm() {
      this.$v.$reset()
      this.localCurrentTrip = null;
      this.form.id = null
      this.form.nezasa_id = null
      this.form.branding = null
      this.form.mitarbeiter = null,
      this.form.sales_firstname = null
      this.form.sales_lastname = null
      this.form.sales_user_id = null
      this.localCurrentTrip = null
      this.trip = null
    },
    async saveBranding(){
      document.getElementById("uploadButton2").disabled = true; 
      let myData = {
        branding: this.form.branding,
        trip: this.localCurrentTrip?.nezasa_id
      }
      let self = this;
      self.doPost({data: myData}, 'updateBrandingImport', res => {
                if (res.data.status === 'error' || res.data.status === 400) {
                  self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
                  self.options.showError = true;
                  self.$emit('updateData', {});
                  self.closeDialog();
                } else {
                      self.options.showSuccessTripId = self.localCurrentTrip?.nezasa_id;
                      self.showSuccessMsg(self.options.Lang.saveBrand)
                      self.$emit('updateData', {});
                      self.closeDialog();
                    
                    }
            });
    },
    async save() {
      this.ladebalken = true;
      document.getElementById("uploadButton").disabled = true;
      if(this.localCurrentTrip){
        document.getElementById("uploadButton2").disabled = true; 
      }
      const self = this;
      let lower = self.form.nezasa_id.toLowerCase();
      self.form.nezasa_id = lower.replace(/\s/g, '');
      self.$v.$touch()
      if (self.$v.$invalid) {
        return false;
      }
      self.form.autoImport = !!self.localCurrentTrip?.autoImport;
      self.sending = true;
      await self.doPost({data: ''}, 'setLoading', res => {
        document.getElementById("uploadButton").disabled = true;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
      document.getElementById("uploadButton").disabled = true;
      if(self.form.nezasa_id.length === 12){
        const isReimport = self.localCurrentTrip?.isReimport === true;
        if(!isReimport){
          let checkID = self.form.nezasa_id;
          await this.doPost({data: checkID}, 'getPublicTripById', res => {
            if (res.data.status === 'error' || res.data.status === 400) {
              self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
              self.options.showError = true;
              self.$emit('updateData', {});
              self.closeDialog();
            }else{
              let result = res.data.data;
              if (result.length === 0) {
                self.doPost({
                  userdata: self.options.user,
                  data: self.form,
                  test: self.options,
                  lang_code: self.options.globalinfo?.sprache || 'en'
                }, 'test/import', async res => {
                  self.sending = false;
                  if (res.data.status === 'error' || res.data.status === 400) {
                    self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
                    self.options.showError = true;
                    self.$emit('updateData', {});
                    self.closeDialog();
                  } else {
                    if (res.data.data === "paxInfo") {
                      self.showErrorMsg(self.options.Lang.errorMsg.noTrip);
                      self.$emit('updateData', {});
                      self.closeDialog();
                    } else {
                      if (res.data.data === "noTrip") {
                        self.showErrorMsg(self.options.Lang.errorMsg.noTrip)
                        self.$emit('updateData', {});
                        self.closeDialog();
                      } else {
                        let id = self.form.nezasa_id;
                        await self.setLoginCode(id)
                        self.ladebalken = true;
            /*            await self.getItinerary(id);*/
                        self.options.showSuccessTripId = id;
                        await self.getLadebalken()
                        await self.setPdfStatus(id)
                        self.$emit('updateData', {});
                      }
                    }
                  }
                });
              }else{
                self.sending = false;
                self.options.showSuccessTrip = self.form.nezasa_id;
                self.showSuccessMsg("Die Trip-ID wurde bereits importiert.")
                self.$emit('updateData', {});
                self.closeDialog();
              }
            }
          });
        }else{
          //await self.resetTrip(self.form.nezasa_id);
          document.getElementById("uploadButton").disabled = true;
          await this.doPost({userdata: self.options.user, data: self.form, passolution: self.options.ModulPassolution, branding: self.form.branding},self.localCurrentTrip ?  'test/re-import' : 'test/import', async res => {
            self.sending = false;
            if (res.data.status === 'error' || res.data.status === 400) {
              self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
              self.options.showSuccessTripId = self.form.nezasa_id;
              self.options.showError = true;
              self.$emit('updateData', {});
              self.closeDialog();
            } else {
              if (res.data.data === "paxInfo"){
                self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
                self.options.errorMsg = self.options.Lang.errorMsg.noTrip;
                self.options.showError = true;
                self.$emit('updateData', {});
                self.closeDialog();
              }else{
                self.rmvpdfsFromTrip();
                let id = self.form.nezasa_id;
                self.ladebalken = true;
               //await self.getItinerary(id);
                self.options.showSuccessTripId = id;
                self.getLadebalken()
                await self.setPdfStatus(id)
                self.$emit('updateData', {});
              }
            }
          });
        }
      }else{
        self.options.showError = true;
        self.$emit('updateData', {});
        self.closeDialog();
      }
      document.getElementById("uploadButton").disabled = true;
    },
    openDialog() {
      console.log("Open Dialog")
    },
    rmvpdfsFromTrip(){
      let myData = {
        id : this.form.nezasa_id
      }
      let self = this;
      self.doPost({data: myData}, 'rmvpdfsFromTrip', res => {
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        } else {
          const result = res.data?.data;
          if (Array.isArray(result) && result.length > 0 && result[0]?.importLoad !== undefined) {
            self.amount = result[0].importLoad;
          }
        }
      });
    },
    getLadebalken(){
      this.options.showSuccess = true;
      this.$emit('updateData', {});
      this.closeDialog();
    },
    closeDialog() {
      this.clearForm();
      this.options.showImportTripForm = false;
      this.options.localCurrentTrip = null;
      localStorage.removeItem('autoImportId');
      localStorage.setItem('onImport', false);
    },
    validate() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.save()
      }
    },
    async resetTrip(id){
      let self = this;
      await self.doPost({userdata: self.options.user, data: id}, 'resetTrip', res => {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    async getItinerary(id) {
      let self = this;
      await self.doPost({userdata: self.options.user, data: id, brand: this.form.branding}, 'createDataItinerary', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        } else {
          self.getAreas(id);
          self.getActivities(id);
          self.getAccountDetails(id);
          self.getRentals(id);
          self.getUpsellItems(id);
          self.getAdhocHotelData(id);
          self.getTransferData(id)
          self.getGeneralAdHoc(id)
        }
      });
    },
    getTransferData(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id}, 'getTransferData', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    getAdhocHotelData(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id}, 'createHotelAdHocData', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    getUpsellItems(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id, brand: this.form.branding}, 'createDataUpsells', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    getRentals(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id, brand:this.form.branding}, 'createDataRentals', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        } else {
          self.getAccountDetails(id);
        }
      });
    },
    getAccountDetails(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id}, 'createDataAccommodationsDetails', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        } else {
          self.getAreas(id);
        }
      });
    },
    getGeneralAdHoc(id){
      let self = this;
      self.doPost({userdata: self.options.user, nezasaId: id, brandingId:self.form.branding}, 'adhoc/save', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
        }
      });
    },
    getActivities(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id}, 'createDataActivitiesDetails', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    getAreas(id){
      let self = this;
      self.doPost({userdata: self.options.user, data: id}, 'createDataAreasDetails', res =>
      {
        self.sending = false;
        if (res.data.status === 'error' || res.data.status === 400) {
          self.help ? self.help.log(self.$t(res.msg), false, true) : console.log(res.msg);
          self.$emit('updateData', {});
        }
      });
    },
    async setPdfStatus(id){
      let data = {
        tripId : id,
        status : "false"
      }
      await this.doPost({ data: data }, 'setStatusPdf', res =>
      {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        }
      });
    }
  }
}
</script>
<style lang="scss">
#nezasa_id{
  -webkit-text-fill-color: black !important;
}

.md-select.md-disabled,
.md-select.md-disabled .md-input {
  opacity: 0.6 !important;
  background-color: #f5f5f5 !important;
  color: #999 !important;
}

.md-select.md-disabled .md-select-value {
  color: #999 !important;
}
.import-trip-dialog {
   width: 899px !important;
   max-width: 899px !important;

   border-radius: 13px !important;
  margin: auto !important;
 }

/* HEADER */
.header-row {
  display: flex;
  position: relative;
  padding-top: 48px;
  padding-bottom: 53.5px;
}

.dialog-title {
  font-size: 30px !important;
  font-weight: 500 !important;
  margin-left: 70px !important;
}
/* COPY ICON */
.copy-icon {
  cursor: pointer;
}

/* CONTENT AREA */
.content-area {
  padding: 70px 70px 40px 70px;
  border-top: 1px solid #e9e9e9;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px 60px;
}

/* ACTIONS */
.actions-row {
  padding: 20px 70px 30px 70px !important;
  padding-bottom: 100px !important;
  padding-top: 41px !important;
  display: flex !important;
  justify-content: space-between !important;
  border-top: 1px solid #e9e9e9;
}

.right-actions {
  display: flex;
}

/* hover: darker "active" look */


.import-trip-dialog.import-mode {
   width: 1100px !important;   /* bigger for import */
   max-width: 1100px !important;
 }

/* Align fields better ONLY in import mode */
.import-trip-dialog.import-mode .form-grid {
  grid-template-columns: 1fr 1fr !important;
  column-gap: 10px;
  row-gap: 50px;
}

/* Optional: Larger spacing for header area */
.import-trip-dialog.import-mode .content-area {
  padding: 60px 20px 60px 20px !important;
}
.blurred-content {
  filter: blur(4px);
  opacity: 0.3;
  pointer-events: none; /* prevents clicking behind blur */
  user-select: none;
}
.font-600{
  font-weight: 600 !important;
}
/* hide default SVG arrow */
.import-trip-dialog .md-menu.md-select > .md-icon svg {
  display: none !important;
}

/* show custom arrow instead */
.import-trip-dialog .md-menu.md-select > .md-icon.md-icon-image {
  background-image: url('@/assets/images/icons/arrow-down.svg') !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 16px !important;
  width: 24px !important;
  height: 24px !important;
  color: transparent !important;
}
.grid-full {
  grid-column: 1 / -1 !important;
}
</style>